<template>
    <div v-if="hasMacroData" class="macro-widget-container">
        <transition name="macro-expand">
            <div
                v-if="isExpanded"
                class="macro-widget-expanded bg-white rounded-full shadow-lg px-5 py-3 flex items-center justify-between"
            >
                <div class="flex items-center justify-around flex-1 gap-3">
                    <div class="macro-item text-center">
                        <div
                            class="macro-value text-xl font-bold text-gray-900"
                        >
                            {{ protein }}g
                        </div>
                        <div class="macro-label text-xs text-gray-700">
                            Protein
                        </div>
                    </div>
                    <div class="macro-item text-center">
                        <div
                            class="macro-value text-xl font-bold text-gray-900"
                        >
                            {{ carbs }}g
                        </div>
                        <div class="macro-label text-xs text-gray-700">
                            Carbs
                        </div>
                    </div>
                    <div class="macro-item text-center">
                        <div
                            class="macro-value text-xl font-bold text-gray-900"
                        >
                            {{ fats }}g
                        </div>
                        <div class="macro-label text-xs text-gray-700">
                            Fat
                        </div>
                    </div>
                    <div class="macro-item text-center">
                        <div
                            class="macro-value text-xl font-bold text-gray-900"
                        >
                            {{ calories }}
                        </div>
                        <div class="macro-label text-xs text-gray-700">
                            Cal
                        </div>
                    </div>
                </div>
                <button
                    class="macro-close-btn ml-3 p-1.5 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
                    @click="toggleExpanded"
                >
                    <svg
                        class="w-5 h-5 text-gray-600"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M6 18L18 6M6 6l12 12"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        ></path>
                    </svg>
                </button>
            </div>
            <button
                v-else
                class="macro-widget-collapsed bg-white rounded-full shadow-lg px-3 py-2 flex items-center justify-center"
                @click="toggleExpanded"
            >
                <svg
                    class="w-5 h-5 text-gray-700"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                </svg>
            </button>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'MacroWidget',
    props: {
        protein: {
            type: Number,
            default: null
        },
        carbs: {
            type: Number,
            default: null
        },
        fats: {
            type: Number,
            default: null
        },
        calories: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            isExpanded: false
        };
    },
    computed: {
        hasMacroData() {
            return (
                this.protein !== null ||
                this.carbs !== null ||
                this.fats !== null ||
                this.calories !== null
            );
        }
    },
    methods: {
        toggleExpanded() {
            this.isExpanded = !this.isExpanded;
        }
    }
};
</script>

<style scoped>
.macro-widget-container {
    position: relative;
    z-index: 40;
}

.macro-widget-collapsed {
    margin: 0 auto;
    width: fit-content;
}

.macro-widget-expanded {
    width: 100%;
    max-width: 100%;
}

.macro-expand-enter-active,
.macro-expand-leave-active {
    transition: all 0.3s ease;
}

.macro-expand-enter,
.macro-expand-leave-to {
    opacity: 0;
    transform: scale(0.95);
}

.macro-item {
    min-width: 60px;
}

.macro-value {
    line-height: 1.2;
}

.macro-label {
    line-height: 1.2;
    margin-top: 2px;
}
</style>
